/**
 * Configuration centralisée des URLs d'API du frontend public.
 *
 * - `API_URL` : base des appels REST (inclut le suffixe `/api`).
 * - `SERVER_BASE` : racine du serveur, sans `/api` (utile pour résoudre les
 *   chemins de fichiers statiques : images de marqueurs, tiles, illustrations, etc.).
 */
export const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4001/api').replace(/\/$/, '');
export const SERVER_BASE = API_URL.replace(/\/api\/?$/, '');

/**
 * Résout un chemin de fichier issu de l'API (upload, icône de catégorie,
 * illustration, image de `donneesPersonnalisees`, etc.) en URL utilisable
 * par le navigateur.
 *
 * - En développement, ces chemins sont relatifs au serveur (`/uploads/...`)
 *   et doivent être préfixés par `SERVER_BASE`.
 * - En production (stockage S3), ils sont déjà des URLs absolues et doivent
 *   être renvoyés tels quels (les préfixer casserait l'URL).
 *
 * Retourne une chaîne vide si `path` est vide/absent, pour un usage direct
 * en tant que `src` sans vérification supplémentaire côté appelant.
 */
export function resolveAssetUrl(path?: string | null): string {
  if (!path) return '';
  return /^https?:\/\//i.test(path) ? path : `${SERVER_BASE}${path}`;
}
